<template>
  <section class="mh-about" id="about">
    <div class="container">
      <div class="row section-separator">
        <div class="col-sm-12 col-md-6">
          <div
            class="mh-about-img shadow-2 wow fadeInUp"
            data-wow-duration="0.8s"
            data-wow-delay="0.4s"
          >
            <img
              :src="
                $store.getters.getAboutImgUrl != '' ||
                typeof $store.getters.getAboutImgUrl != 'undefined'
                  ? $store.getters.getAboutImgUrl
                  : '/images/ab-img.png'
              "
              alt
              class="img-fluid img-responsive"
            />
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="mh-about-inner">
            <h2
              class="wow fadeInUp"
              data-wow-duration="0.8s"
              data-wow-delay="0.1s"
            >
              About Me
            </h2>
            <p
              class="wow fadeInUp"
              data-wow-duration="0.8s"
              data-wow-delay="0.2s"
              v-text="$store.getters.getAbout"
            ></p>
            <div
              class="mh-about-tag wow fadeInUp"
              data-wow-duration="0.8s"
              data-wow-delay="0.3s"
            >
              <ul>
                <li v-for="(skill, index) in skills" :key="index">
                  <span v-html="skill.name"></span>
                </li>
              </ul>
            </div>
            <a
              :href="$store.getters.getCVUrl"
              target="_blank"
              class="btn btn-fill wow fadeInUp"
              data-wow-duration="0.8s"
              data-wow-delay="0.4s"
            >
              Downlaod my CV
              <i class="fa fa-download"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setSkills") {
        if (state.skills != null) {
          this.skills = state.skills;
        }
      }
    });
  },
};
</script>
